/* eslint-disable yoda */
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';

import ListingStatus from '../../_v2/features/pause-listing/components/ListingStatus';

import { StatsigContext } from '../../elements-statsig-provider/statsig-context';

export const LISTING_TYPE = {
  Production: {
    id: 'pause.calendar.production',
    defaultMessage: 'Production listing'
  },
  'Off-Site': {
    id: 'pause.calendar.meetings',
    defaultMessage: 'Meetings listing'
  },
  Event: {
    id: 'pause.calendar.events',
    defaultMessage: 'Events listing'
  }
};

const CalendarListingStatus = ({ useType, status, id }) => {
  const {
    featureGates
  } = useContext(StatsigContext);

  const isEnabled = featureGates.pause_listing ?? false;

  const listingType = LISTING_TYPE[useType];

  if (!listingType || !isEnabled) {
    return null;
  }

  const handleResumeListingClick = () => {
    window.location.href = `/mylistings/${id}?openModal=true`;
  }

  return (
    <>
      <div className="calendar-listing-status">
        <div>
          <Text typeface="headline-2-m">
            <FormattedMessage id={listingType?.id} defaultMessage={listingType?.defaultMessage} />
          </Text>
        </div>
        <div className="status-container">
          <ListingStatus status={status} />
          <Button
            variant="underline-m"
            onClick={handleResumeListingClick}
          >
            <FormattedMessage id="pause.status.resume_listing" defaultMessage="Resume listing" />
          </Button>
        </div>
      </div>
      <hr />
    </>
  );
};

CalendarListingStatus.propTypes = {
  status: PropTypes.string,
  id: PropTypes.string,
  useType: PropTypes.string
};

CalendarListingStatus.defaultProps = {
  status: '',
  id: '',
  useType: ''
};

export default CalendarListingStatus;
